import { useEffect } from "react";

export function useEventListener(
  eventName: string,
  handler: (event: any) => void,
  element?: React.RefObject<any>,
  options?: boolean | AddEventListenerOptions
) {
  useEffect(() => {
    const targetElement = element?.current ?? window;

    if (!(targetElement && targetElement.addEventListener)) return;

    targetElement.addEventListener(eventName, handler, options);

    return () => {
      targetElement.removeEventListener(eventName, handler, options);
    };
  }, [eventName, element, handler, options]);
}
